export abstract class LoadingService<TConfig, TParams> {
  protected readonly config: TConfig;

  constructor(config: TConfig) {
    this.config = config;
  }

  abstract getLoadingTime(params: TParams): number;
}
